import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import InfoTwoToneIcon from '@mui/icons-material/InfoTwoTone';
import parse from 'html-react-parser';

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 350,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}));

export default function CustomizedTooltips({ msg }) {
    return (
        <div>
            <HtmlTooltip
                placement="right"
                title={
                    <>
                        <Typography color="inherit">{parse(msg)}</Typography>
                        {/* <em>{"And here's"}</em> <b>{'some'}</b> <u>{'amazing content'}</u>.{' '}
                        {"It's very engaging. Right?"} */}
                    </>
                }
            >
                <InfoTwoToneIcon />
            </HtmlTooltip>
        </div>
    );
}
